
export class FuncoeslimparFormatacao {

  public static limparDados(valor): string {
    if (valor) {
      valor = valor.toString();
      valor = valor.replace(/[^a-z0-9]/gi, '');
      valor = valor.substring(0, 11)
    }
    return valor;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/funcoes-limpar-formatacao.ts